<template>
    <div class="basicInformationBox">
        <div class="basicInformationcontent">
            <!--<div class="tip">
                <i class="el-icon-warning"></i>
                180天内企业名称应可以修改3次，您当前还可以修改{{ 3-form.updateNum }}次，请谨慎填写
            </div>-->
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="模板背景图" prop="templateNo">
                    <el-select v-model="form.templateNo" clearable placeholder="模板背景图" @change="showImg">
                        <el-option label="模板一" value="one"> </el-option>
                        <el-option label="模板二" value="two"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板样式" >
                    <!--<img src="@/assets/images/base_one.png" style="width: 60%;height: 60%" v-if="form.templateNo=='one'" />
                    <img src="@/assets/images/base_two.png" style="width: 60%;height: 60%" v-else />-->
                    <el-image
                        style="width: 300px; height: 300px"
                        :src="url"
                        :preview-src-list="srcList">
                    </el-image>
                </el-form-item>
                <el-table ref="table"
                          :data="form.menuSettingList"
                          :row-class-name="tableRowClassName"
                          style="width: 100%;">

                    <el-table-column prop="menuName" label="菜单名称">
                        <template slot-scope="scope">
                            <span>{{scope.row.menuName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sort" label="排序">
                        <template slot-scope="scope">
                            <el-input-number size="mini" v-model="scope.row.sort" :min="0" :max="99" placeholder="请输入排序"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>

                <el-form-item class="submitButtonGroup">
                    <el-button type="primary" @click="submitForm()">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {
        currentPageSettingInfo,
        designerByUserId, getNewcurrent,
        savePageSetting,
        updatePageSetting
    } from '../../utils/interface';

    export default {
        name: "pageSetting",
        data(){
            return{
                form: {
                    uuid:'',
                    templateNo: '',
                    menuSettingList:[],
                },
                rules: {
                    templateNo: [
                        { required: true, message: '请选择模板', trigger: 'blur' }
                    ],
                },
                pageType:'',
                tabList:[],
                url: require('../../assets/images/base_three.png'),
                srcList: [
                    require('../../assets/images/base_three.png')
                ],
            }
        },
        created(){
            this.getDesignerViewDetail();
        },
        methods: {
            tableRowClassName: function (row, index) {
                if (this.pageType=='BOTH' || row.row.type == this.pageType ||row.row.type=='BOTH') {
                    return '';
                }else {
                    return 'hidden-row';
                }

            },
            // 保存
            submitForm() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.form.uuid){
                            updatePageSetting(this.form).then((res)=>{
                                this.$message.success("修改成功");
                                this.getDesignerViewDetail();
                            })
                        }else {
                            savePageSetting(this.form).then((res)=>{
                                this.$message.success("保存成功");
                                this.getDesignerViewDetail();
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            getDesignerViewDetail(){
                getNewcurrent().then((res)=>{
                        // 查询店铺信息区分店铺是服务商还是商家信息
                    designerByUserId(res.uuid).then((res)=>{
                            if(res != null){
                                this.getPageSettingInfo();
                                this.pageType = res.type;
                                if(res.type == 'BOTH'){
                                    this.tabList= [
                                        {
                                            menuName: '我的模型',
                                            type: 'MODEL',
                                            sort:99,
                                        },
                                        {
                                            menuName: '我的简介',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                        {
                                            menuName: '平面设计',
                                            type: 'GRAPHIC',
                                            sort:99,
                                        },
                                        {
                                            menuName: '成果展示',
                                            type: 'MODEL',
                                            sort:99,
                                        },
                                        {
                                            menuName: '评论列表',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                        {
                                            menuName: '成交记录',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                    ];
                                }else if(res.type == 'MODEL'){
                                    this.tabList= [
                                        {
                                            menuName: '我的模型',
                                            type: 'MODEL',
                                            sort:99,
                                        },
                                        {
                                            menuName: '我的简介',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                        {
                                            menuName: '成果展示',
                                            type: 'MODEL',
                                            sort:99,
                                        },
                                        {
                                            menuName: '评论列表',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                        {
                                            menuName: '成交记录',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                    ];
                                }else if(res.type == 'GRAPHIC'){
                                    this.tabList= [
                                        {
                                            menuName: '我的简介',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                        {
                                            menuName: '平面设计',
                                            type: 'GRAPHIC',
                                            sort:99,
                                        },
                                        {
                                            menuName: '评论列表',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                        {
                                            menuName: '成交记录',
                                            type: 'BOTH',
                                            sort:99,
                                        },
                                    ];
                                }

                            }
                        });
                });
            },
            getPageSettingInfo(){
                currentPageSettingInfo().then((res)=>{
                    if(res.success){
                        if(res.data !=null){
                            if(res.data.menuSettingList.length>0){
                                this.form = res.data;
                            }else{
                                this.form.menuSettingList = this.tabList;
                            }
                        }else {
                            this.form.templateNo='one';
                            this.form.menuSettingList = this.tabList;
                        }

                        if(this.form.templateNo=="one"){
                            this.url=require('../../assets/images/base_three.png');
                            this.srcList.push(require('../../assets/images/base_three.png'));
                        }else if(this.form.templateNo=="two"){
                            this.url=require('../../assets/images/base_four.png');
                            this.srcList.push(require('../../assets/images/base_four.png'));
                        }
                    }
                });
            },
            showImg(value){
                this.srcList = [];
                if(value=="one"){
                    this.url=require('../../assets/images/base_three.png');
                    this.srcList.push(require('../../assets/images/base_three.png'));
                }else if(value=="two"){
                    this.url=require('../../assets/images/base_four.png');
                    this.srcList.push(require('../../assets/images/base_four.png'));
                }
            }
        }
    }
</script>

<style scoped lang="less">
    /deep/.hidden-row {
        display: none !important;
    }
    /deep/.el-picker-panel{
        z-index: 99999;
    }
    .basicInformationBox {
        padding: 30px 0;
        .basicInformationcontent {
            max-width: 900px;
            margin: 0 auto;
            padding: 30px 0;
            .tip{
                height: 40px;
                font-size: 12px;
                color: rgb(121, 121, 121);
                border-radius: 8px;
                background: #f4f7ff;
                line-height: 40px;
                padding: 0 20px;
                i{
                    font-size: 18px;
                    padding-right: 5px;
                    vertical-align: sub;
                    color: #157efb;
                }
            }
            .demo-ruleForm{
                padding-top: 30px;
                .thumbnailClass2{
                    width: 130px;
                    height: 130px;
                    margin-left: 16px;
                    margin-bottom: 5px;
                }
                .thumbnailClass{
                    width: 130px;
                    height: 130px;
                    margin-right: 30px;
                    .avatar2{
                        width: 130px;
                        height: 130px;
                        border: 1px dashed #ddd;
                        border-radius: 4px;
                        line-height: 125px;
                        font-size: 50px;
                        margin-left: 16px;
                        p {
                            margin: 0;
                            font-size: 16px;
                        }
                    }
                    .avatar{
                        width: 130px;
                        height: 130px;
                        border: 1px dashed #ddd;
                        border-radius: 4px;
                        line-height: 130px;
                        font-size: 24px;
                    }
                }
                .bannerImgClass{
                    width: 100%;
                    /deep/.el-upload{
                        width: 100%;
                    }
                    .avatar{
                        width: 100%;
                        border: 1px dashed #ddd;
                        border-radius: 4px;
                        line-height: 130px;
                        font-size: 24px;
                    }
                }
                .submitButtonGroup{
                    /deep/.el-form-item__content{
                        margin: 0 !important;
                        text-align: center;
                        button{
                            width: 120px;
                            height: 30px;
                            text-align: center;
                            padding: 0;
                            border-radius: 15px;
                            font-size: 13px;
                            background: #157efb;
                            color: #fff;
                            border: none;
                            outline: none;
                        }
                        .cancelNewTemplate{
                            width: 90px;
                            height: 30px;
                            text-align: center;
                            padding: 0;
                            font-weight: 700;
                            border-radius: 15px;
                            font-size: 13px;
                            background: #e4e4e4;
                            color: #868686;
                            border: none;
                            outline: none;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/pageSetting/pageSettingManage.vue